import isUndefined from 'lodash/isUndefined';
import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n/index';
import { getLayerAgentOperateConfig } from '@/utils/agent-teams-kit';
import { deleteExtraInfo } from '@/utils/layer-kit';
import { traverseTree } from '@/utils/tree-kit';
import {
    LayerType,
    type IExportBehavior,
    type IGroupLayerProps,
    type ILayerBehavior,
    type ILayerProps,
    type ISize,
} from '@/version-types';
import { EdgelessGroupLayer } from './edgeless-layer';
import { GroupThumbnail } from './thumbnail';

function checkDisableAgentBaseOperate(layer: ILayerProps, key: 'rotate' | 'scale' | 'resize') {
    let isDisabled = false;

    traverseTree(layer, (item: ILayerProps) => {
        if (item.id === layer.id || isDisabled) return;
        if (getLayerAgentOperateConfig(item)?.disable?.[key]) {
            isDisabled = true;
        }
    });

    return isDisabled;
}

function getBehavior(identity: string) {
    const layerBehavior: ILayerBehavior = {
        getEdgelessObject(layer: ILayerProps) {
            return new EdgelessGroupLayer(layer.id, getFramework(identity));
        },

        async getResultCanvasAsync(layer: ILayerProps, resultSize: ISize): Promise<HTMLCanvasElement | undefined> {
            return;
        },
        onBeforeAddOrUpdate(layer: ILayerProps) {
            if (isUndefined(layer.data) || isUndefined((layer.data as IGroupLayerProps)?.isExtraGroup)) {
                layer.data = {
                    ...layer.data,
                    isExtraGroup: false,
                } as IGroupLayerProps;
            }
        },
        async onBeforeSaveAsync(layer: ILayerProps, isAutoSave?: boolean) {
            deleteExtraInfo(layer);
            delete (layer as any).data.isExtraGroup;
            delete (layer as any).data.isVip;
        },
        getMenuOverlapName(layer: ILayerProps) {
            const { $t } = getLocaleStore();
            return $t((v) => v.layers.group);
        },
        getMenuOverlapIcon(layer: ILayerProps) {
            return <GroupThumbnail identity={identity} layerId={layer.id} />;
        },
        getScaleIsNeedLimitSize() {
            return true;
        },

        disableDefaultScaleOperate(layer: ILayerProps) {
            return checkDisableAgentBaseOperate(layer, 'scale');
        },

        disableDefaultResizeOperate(layer: ILayerProps) {
            return checkDisableAgentBaseOperate(layer, 'resize');
        },

        disableDefaultRotateOperate(layer: ILayerProps) {
            return checkDisableAgentBaseOperate(layer, 'rotate');
        },
    };
    return layerBehavior;
}

const exportBehavior: IExportBehavior = {
    layerType: LayerType.GROUP_LAYER,
    getBehavior,
};

export default exportBehavior;
